import PropTypes from 'prop-types'
import { useTranslation } from 'react-i18next'

import Button from '../Button'
import styles from './Page404.module.scss'

const Page404 = ({ goTo }) => {
  const { t } = useTranslation()
  return (
    <div className={styles.page404}>
      <div className={styles.content}>
        <h2>404</h2>
        <p>{t('Parece que algo no está funcionando bien')}</p>
        <Button
          classes={[styles.homeButton, { second: true }]}
          id='goHomeButton'
          onPress={() => goTo()}
        >
          {t('Volver a la página de inicio')}
        </Button>
      </div>
    </div>
  )
}
Page404.defaultProps = {
  goTo: null,
}

Page404.propTypes = {
  goTo: PropTypes.func,
}

export default Page404
